export default function SpecialSpeakerIcon({ gray }: { gray?: boolean }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36" fill="none">
            <g>
                <path
                    d="M18 5.625C12.6534 5.625 8.625 9.30721 8.625 13.5V15.3929C8.625 15.5941 8.79885 15.75 9 15.75H12C13.2426 15.75 14.25 16.7574 14.25 18V25.5C14.25 26.7426 13.2426 27.75 12 27.75H9C6.92893 27.75 5.25 26.0711 5.25 24V19.5C5.25 17.592 6.375 15.7469 6.375 13.8389V13.5C6.375 7.75167 11.7486 3.375 18 3.375C24.2514 3.375 29.625 7.75167 29.625 13.5V13.8389C29.625 15.7469 30.75 17.592 30.75 19.5V24C30.75 26.0711 29.0711 27.75 27 27.75H24C22.7574 27.75 21.75 26.7426 21.75 25.5V18C21.75 16.7574 22.7574 15.75 24 15.75H27C27.2012 15.75 27.375 15.5941 27.375 15.3929V13.5C27.375 9.30721 23.3466 5.625 18 5.625Z"
                    fill={gray ? 'url(#special_speaker_radial_gray)' : 'url(#special_speaker_radial_color)'}
                />
                <path
                    d="M18 3.875C24.0527 3.875 29.125 8.09936 29.125 13.5V13.8389C29.125 14.8789 29.4319 15.889 29.709 16.8135C29.9943 17.7653 30.25 18.6323 30.25 19.5V24C30.25 25.7949 28.7949 27.25 27 27.25H24C23.0335 27.25 22.25 26.4665 22.25 25.5V18C22.25 17.0335 23.0335 16.25 24 16.25H27C27.445 16.25 27.875 15.9011 27.875 15.3926V13.5C27.875 8.96409 23.5506 5.125 18 5.125C12.4494 5.125 8.125 8.96409 8.125 13.5V15.3926C8.125 15.9011 8.55502 16.25 9 16.25H12C12.9665 16.25 13.75 17.0335 13.75 18V25.5C13.75 26.4665 12.9665 27.25 12 27.25H9C7.20507 27.25 5.75 25.7949 5.75 24V19.5C5.75 18.6323 6.0057 17.7653 6.29102 16.8135C6.56813 15.889 6.875 14.8789 6.875 13.8389V13.5C6.875 8.09936 11.9473 3.875 18 3.875Z"
                    stroke="url(#paint1_linear_1093_24751)"
                    strokeOpacity="0.2"
                />
            </g>
            <defs>
                <radialGradient
                    id="special_speaker_radial_color"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(5.35805 5.71875) rotate(46.0848) scale(36.7651 107.017)"
                >
                    <stop stopColor="#FCE640" />
                    <stop offset="0.770739" stopColor="#F49629" />
                    <stop offset="1" stopColor="#F17E22" />
                </radialGradient>
                <radialGradient
                    id="special_speaker_radial_gray"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(5.35805 5.71875) rotate(46.0848) scale(36.7651 107.017)"
                >
                    <stop stopColor="#E9E9E9" />
                    <stop offset="0.770739" stopColor="#8f8f8f" />
                    <stop offset="1" stopColor="#8a8a8a" />
                </radialGradient>
                <linearGradient
                    id="paint1_linear_1093_24751"
                    x1="18"
                    y1="3.375"
                    x2="18"
                    y2="27.75"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.05" />
                </linearGradient>
            </defs>
        </svg>
    )
}
